/* eslint-disable react/destructuring-assignment, one-var */

import Modal from "react-bootstrap-modal";
import PropTypes from "prop-types";
import React from "react";

class WishlistMoreBanner extends React.PureComponent {

  static propTypes = {
    "confirmModalOpen": PropTypes.bool.isRequired,
    "display": PropTypes.bool.isRequired,
    "lessThanOneDayOld": PropTypes.bool.isRequired,
    "requestsNeeded": PropTypes.number.isRequired
  }

  constructor (props) {
    super(props);

    this.state = {"showModal": false};
  }

  closeModal = () => this.setState({"showModal": false});

  openModal = () => this.setState({"showModal": true});

  render () {
    const {confirmModalOpen, display, lessThanOneDayOld, requestsNeeded} = this.props,
      {showModal} = this.state,
      {closeModal, openModal} = this;
    return (
      <React.Fragment>
        {
          display && requestsNeeded > 0
            ? (
              <div className="fw-bg wishlist-banner-container desktop-only">
                <div className="center wishlist-more-banner color-periwinkle-2-bg">
                  {
                    lessThanOneDayOld
                      ? (
                        <div>
                          {`Wishlist ${requestsNeeded} more to earn $5 credit`}
                          <div
                            className="inline-block why-wishlist-button ml24"
                            onClick={openModal}
                          >
                            ?
                          </div>
                        </div>
                      )
                      : `Wishlist ${requestsNeeded} more to improve your next set`
                  }
                </div>
              </div>
            )
            : null
        }
        {lessThanOneDayOld && confirmModalOpen === null &&
          <Modal
            onHide={closeModal}
            show={showModal}
          >
            <Modal.Body>
              <button
                className="close"
                onClick={closeModal}
                type="button"
              >
                &times;
              </button>
              <h4 className="center">
                Why Wishlist?
              </h4>
              <p className="center">
                Wishlisting helps us find styles
                <br />
                {"you'll love! Wishlist 30 now to earn"}
                <br />
                $5 Shopping Credit!
              </p>
              <Modal.Dismiss className="btn btn-primary centered get-money-button">
                Get $5
              </Modal.Dismiss>
            </Modal.Body>
          </Modal>
        }
      </React.Fragment>
    );
  }
}

WishlistMoreBanner.propTypes = {
  "display": PropTypes.bool.isRequired,
  "lessThanOneDayOld": PropTypes.bool,
  "requestsNeeded": PropTypes.number.isRequired
};

WishlistMoreBanner.defaultProps = {"lessThanOneDayOld": false};

export default WishlistMoreBanner;
